module.exports = __webpack_public_path__ + "static/media/PYC ĐỀ NGHỊ HỦY GIAO DỊCH THẺ- HOÀN TRẢ PHÍ.f296392d.pdf";